import ACTIONS from "../actions/types";

const initialState = {
  isFetchingOrganizations: false,
  selectedorganization: {},
  orgDevicesList:[]
};
const organizationsReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case ACTIONS.ORGANIZATIONS.FETCH_ALL_ORGANIZATIONS_LIST_START:
      return {
        ...state,
        isFetchingOrganizations: true
      };
    case ACTIONS.ORGANIZATIONS.FETCH_ALL_ORGANIZATIONS_LIST_SUCCESS:
      return {
        ...state,
        isFetchingOrganizations: false,
        organizations: payload
      };
    case ACTIONS.ORGANIZATIONS.FETCH_ALL_ORGANIZATIONS_LIST_FAILURE:
      return {
        ...state,
        isFetchingOrganizations: false,
        errorMessage: payload
      };

    case ACTIONS.ORGANIZATIONS.FETCH_ORGANIZATION_INFO:
      return {
        ...state,
        isFetchingOrganizations: false,
        selectedorganization: { ...payload }
      };

    case ACTIONS.ORGANIZATIONS.FETCH_ORGANIZATION_INFO_FAILURE:
      return {
        ...state,
        isFetchingOrganizations: false,
        selectedorganization: {}
      };

    case ACTIONS.ORGANIZATIONS.FETCH_ORGANIZATION_ABILITY_START:
      return {
        ...state
      };
    case ACTIONS.ORGANIZATIONS.FETCH_ORGANIZATION_ABILITY_SUCCESS:
      return {
        ...state
      };
    case ACTIONS.ORGANIZATIONS.FETCH_ORGANIZATION_ABILITY_FAILURE:
      return {
        ...state
      };

    case ACTIONS.ORGANIZATIONS.FETCH_ORGANIZATION_DEVICES_LIST:
      return {
        ...state,
        orgDevicesList: [...payload]
      };

    case ACTIONS.ORGANIZATIONS.FETCH_ORGANIZATION_DEVICES_LIST_FAILURE:
      return {
        ...state,
        orgDevicesList: []
      };

    default:
      return { ...state };
  }
};
export default organizationsReducer;
